import type { MessageSchema } from '@/i18n/types';

const kk: MessageSchema['errors'] = {
    forbidden: 'Кіруге тыйым салынған',
    notFound:  'Бет табылмады',
};

export default kk;
